module.exports = __webpack_public_path__ + "img/DE01050.f6594bda.png";